import * as S from "../../Style/Page/Social.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import HatPageTopLine from "../../Component/SocialPageTopLine.js";
// const Img1 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/01.350120449f5042d5b766.png`;
// const Img2 = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/02.b1e864819b191bec9d95.png`;
import Img1 from "../../assets/Wbh/img1.png";
import Img2 from "../../assets/Wbh/img2.png";
// const Img1e = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/01-e.9559c55cba0ba296ef7a.png`;
// const Img2e = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/02-e.038e11e9904cdf985db6.png`;
import Img1e from "../../assets/Wbh/img1e.png";
import Img2e from "../../assets/Wbh/img2e.png";
const Wbh = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"WBH"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/WBH/WBH">WBH</Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">모자사업</Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">지게차사업</Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">자동차사업</Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">버스사업</Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">일반사업</Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">사회사업</Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"52px"}>
            <S.NavItem>
              <Link to="/WBH/WBH">WBH</Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <img src={Img1} alt="" className="fullsize-map kor" />
            <img src={Img2} alt="" className="fullsize-map kor" />
            <img src={Img1e} alt="" className="fullsize-map eng" />
            <img src={Img2e} alt="" className="fullsize-map eng" />
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default Wbh;
